export default __webpack_public_path__ + "static/media/geforce.a1f5187d.jpg";